import { applyFilters, applyUsableFilters, generateErrors } from 'utilities/util';
import { IStore } from 'reducers/index';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { TYPES } from 'action-types/invoices';
import { TYPES as FILTER_TYPES } from 'action-types/filters';
import { callApiV3Put, callApiV3Post, callApiV3Get, callApiV2Post, callApiV1Post } from 'utilities/apiCaller';
import API from 'constants/api';
import { TransportMode } from 'constants/modes';

export const fetchInvoicesData = (pageNumber?: number, pageSize?: number, lastRowNumberFromPreviousResponse?: number) => {
    return async (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
        dispatch({ type: TYPES.FETCH_INVOICES_DATA.PENDING });
        try {
            const res = await callApiV3Post(API.Invoices.GetData, applyFilters(getState, {
                isAirInFilters: false,
                isAirInBody: false
            }, {
                Page: pageNumber,
                PageNumber: pageNumber,
                PageSize: pageSize,
                LastRowNumberFromPreviousResponse: lastRowNumberFromPreviousResponse
            }), { headers: { TransportMode: TransportMode.Ocean } });
            dispatch({ type: FILTER_TYPES.SET_TOTAL_COUNT, totalCount: res.data.totalCount });
            dispatch({ type: TYPES.FETCH_INVOICES_DATA.FULFILLED, invoices: res.data });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: TYPES.FETCH_INVOICES_DATA.REJECTED, errors });
        }
    }
};
export const fetchEtsInvoicesData = (pageNumber?: number, pageSize?: number, lastRowNumberFromPreviousResponse?: number) => {
    return async (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
        dispatch({ type: TYPES.FETCH_ETS_INVOICES_DATA.PENDING });
        try {
            const res = await callApiV3Post(API.Invoices.GetEtsData, applyFilters(getState, {
                isAirInFilters: false,
                isAirInBody: false
            }, {
                Page: pageNumber,
                PageNumber: pageNumber,
                PageSize: pageSize,
                LastRowNumberFromPreviousResponse: lastRowNumberFromPreviousResponse
            }), { headers: { TransportMode: TransportMode.Ocean } });
            dispatch({ type: FILTER_TYPES.SET_TOTAL_COUNT, totalCount: res.data.totalCount });
            dispatch({ type: TYPES.FETCH_ETS_INVOICES_DATA.FULFILLED, etsInvoices: res.data });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: TYPES.FETCH_ETS_INVOICES_DATA.REJECTED, errors });
        }
    }
};
export const fetchInvoiceDetails = (FinOpsInvoiceNumber: string, isOrigin: boolean = true) => {
    if (isOrigin) {
        return async (dispatch: ThunkDispatch<any, any, Action>) => {
            dispatch({ type: TYPES.FETCH_INVOICE_DETAILS.PENDING });
            try {
                const res = await callApiV3Post(API.Invoices.GetInvoiceDetails,
                    { FinOpsInvoiceNumber }, { headers: { TransportMode: TransportMode.Ocean } });
                dispatch({ type: TYPES.FETCH_INVOICE_DETAILS.FULFILLED, invoiceDetails: res.data });
            } catch (e) {
                const errors = generateErrors(e);
                dispatch({ type: TYPES.FETCH_INVOICE_DETAILS.REJECTED, errors });
            }
        }
    }
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.FETCH_ISSO_DETAILS.PENDING });
        try {
            const res = await callApiV3Get(`${API.Invoices.GetISSODetails}/${FinOpsInvoiceNumber}`);
            dispatch({ type: TYPES.FETCH_ISSO_DETAILS.FULFILLED, issoDetails: res.data });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: TYPES.FETCH_ISSO_DETAILS.REJECTED, errors });
        }
    }
};

export const fetchReprintOrDraftStatus = (FinOpsInvoiceNumbers: string[], isOrigin: boolean = true, RequestType: string = 'ViewInvoice') => {
    const targetType = isOrigin ? TYPES.REPRINT_DRAFT_STATUS_VIEW_ORIGIN : TYPES.REPRINT_DRAFT_STATUS_VIEW_DESTINATION;
    const targetAPI = isOrigin ? API.Invoices.getReprintDownloadStatusViewOrigin : API.Invoices.getReprintDownloadStatusViewDest;
    const query = {
        SearchIds: FinOpsInvoiceNumbers,
        RequestType
    }
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: targetType.PENDING });
        try {
            const res = await callApiV2Post(targetAPI,
                query, { headers: { TransportMode: TransportMode.Ocean } });
            dispatch({ type: targetType.FULFILLED, isReprintOrDraftInvoiceAllowed: res.data.isReprintOrDraftInvoiceAllowed });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: targetType.REJECTED, errors });
        }
    }
};

export const fetchInvoicesSearch = (pageNumber?: number, pageSize?: number, isOrigin: boolean = true) => {
    const targetType = isOrigin ? TYPES.SEARCH_INVOICES : TYPES.SEARCH_INVOICES_DESTINATION;
    const targetBFFAPI = isOrigin ? API.Invoices.OriginInvoiceSearch : API.Invoices.DestinationInvoiceSearch;
    return async (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
        dispatch({ type: targetType.PENDING });
        try {
            const res = await callApiV2Post(targetBFFAPI, applyUsableFilters(getState, {
                Page: pageNumber,
                PageSize: pageSize
            }), {});
            dispatch({ type: FILTER_TYPES.SET_TOTAL_COUNT, totalCount: res.data.totalCount });
            dispatch({ type: targetType.FULFILLED, searchInvoices: res.data });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: targetType.REJECTED, errors });
        }
    }
};
export const resetInvoices = () => {
    return async (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
        dispatch({ type: FILTER_TYPES.SET_TOTAL_COUNT, totalCount: 0 });
        dispatch({ type: TYPES.RESET_INVOICES.FULFILLED, invoices: [] });
    }
};

export const resetInvoiced = () => {
    return async (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
        dispatch({ type: FILTER_TYPES.RESET_SORT });
        dispatch({ type: TYPES.RESET_SUBMIT_INVOICES.FULFILLED, invoicedResponse: '' });
    }
};
export const setSelectedInvoices = (list: any[]) => {
    return async (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
        dispatch({ type: TYPES.SET_SELECTED_INVOICES.FULFILLED, invoicesList: list });
    }
};
export const submitInvoices = (data: any) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.SUBMIT_INVOICES.PENDING });
        try {
            const res = await callApiV3Post(API.Invoices.SendData, { ...data }, { headers: { TransportMode: TransportMode.Ocean } });
            dispatch({ type: TYPES.SUBMIT_INVOICES.FULFILLED, invoicedResponse: res.data });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: TYPES.SUBMIT_INVOICES.REJECTED, errors });
        }
    }
};

export const fetchInvoicesHistoryLog = (finOpsInvoiceNumber: string) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.FETCH_INVOICE_HISTORY.PENDING });
        try {
            const res = await callApiV3Get(API.Invoices.GetInvoiceHistory, { finOpsInvoiceNumber }, { headers: { TransportMode: TransportMode.Ocean } });
            dispatch({ type: TYPES.FETCH_INVOICE_HISTORY.FULFILLED, history: res.data });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: TYPES.FETCH_INVOICE_HISTORY.REJECTED, errors });
        }
    }
};
export const raiseCreditNotes = (data: any) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.ADD_CREDIT_NOTES_INVOICES.PENDING });
        try {
            const res = await callApiV3Post(API.Invoices.SendCreditNote, { ...data }, { headers: { TransportMode: TransportMode.Ocean } });
            dispatch({ type: TYPES.ADD_CREDIT_NOTES_INVOICES.FULFILLED, creditNoteResponse: res.data });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: TYPES.ADD_CREDIT_NOTES_INVOICES.REJECTED, errors });
        }
    }
};
export const reprint = (invoiceId: string, data: any) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.REPRINT_INVOICES.PENDING });
        try {
            const res = await callApiV3Put(`${API.Invoices.SendData}/${invoiceId}/${API.Invoices.SendReprint}`, { ...data }, { headers: { TransportMode: TransportMode.Ocean } });
            dispatch({ type: TYPES.REPRINT_INVOICES.FULFILLED, creditNoteResponse: res.data });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: TYPES.REPRINT_INVOICES.REJECTED, errors });
        }
    }
};
/////////
export const generateDownload = (id: string, category: number, fileType: string = 'excel') => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.FETCH_FILE.PENDING });
        try {
            const res = await callApiV3Post(API.Invoices.GetDownload, {
                ids: [id],
                category,
                fileType
            }, {
                headers:
                {
                    'Content-Disposition': 'attachment; filename=template.xlsx',
                    'Content-Type': 'application/vnd.ms-excel'
                },
                responseType: 'arraybuffer',
            });
            dispatch({ type: TYPES.FETCH_FILE.FULFILLED, downloadResponse: res.data });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: TYPES.FETCH_FILE.REJECTED, errors });
        }
    }
};

export const generatePDFDownload = (ids: number[]) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.FETCH_PDF_FILE.PENDING });
        try {
                const res = await callApiV1Post(API.Invoices.GetPDFDownload, {
                    invoiceIds: ids
                }, {
                    headers:
                    {
                        'Content-Disposition': 'attachment; filename=template.pdf',
                        'Content-Type': 'application/json'
                    },
                    responseType: 'arraybuffer',
                });
            dispatch({ type: TYPES.FETCH_PDF_FILE.FULFILLED, downloadPDFResponse: res.data });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: TYPES.FETCH_PDF_FILE.REJECTED, errors });
        }
    }
};

export const fetchCustomerInvoicesSearch = (pageNumber?: number, pageSize?: number) => {
    return async (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
        dispatch({ type: TYPES.FETCH_CUSTOMER_INVOICES_DATA.PENDING });
        try {
            const res = await callApiV2Post(API.Invoices.CustomerInvoiceSearch, applyUsableFilters(getState, {
                Page: pageNumber,
                PageSize: pageSize
            }), {});
            dispatch({ type: FILTER_TYPES.SET_TOTAL_COUNT, totalCount: res.data.totalCount });
            dispatch({ type: TYPES.FETCH_CUSTOMER_INVOICES_DATA.FULFILLED, searchCustomerInvoices: res.data });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: TYPES.FETCH_CUSTOMER_INVOICES_DATA.REJECTED, errors });
        }
    }
};
export const resetCustomerInvoicesSearch = () => {
    return async (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
        dispatch({ type: FILTER_TYPES.SET_TOTAL_COUNT, totalCount: 0 });
        dispatch({ type: TYPES.RESET_CUSTOMER_INVOICES.FULFILLED, customerInvoices: [] });
    }
};